export class LocationSearchParameters {
    locationName: string = '';
    city: string = '';
    state?: string = '';
    locCode?: string = '';
    customerName?: string = '';
    searchTerm?: string = '';
}